export type QuizReviewItem =
  | {
      kind: "options";
      prompt: string;
      codeSnippet?: string;
      options: { label: string; selected: boolean; correct: boolean }[];
      isCorrect: boolean;
      feedback?: string;
    }
  | {
      kind: "cloze";
      prompt: string;
      clozeText: string;
      gapMark: string;
      gaps: { userAnswer: string; correctAnswer: string; correct: boolean }[];
      isCorrect: boolean;
      feedback?: string;
    }
  | {
      kind: "matching";
      prompt: string;
      rows: {
        secondPart: string;
        userTerm: string | null;
        correctTerm: string;
        correct: boolean;
      }[];
      isCorrect: boolean;
      feedback?: string;
    }
  | {
      kind: "text";
      prompt: string;
      userAnswer: string;
      isCorrect: boolean;
      feedback?: string;
    }
  | {
      kind: "code";
      prompt: string;
      userAnswer: string;
      language?: string;
      isCorrect: boolean;
      feedback?: string;
    }
  | {
      kind: "reveal";
      prompt: string;
      blocks: QuizReviewBlock[];
    };

export type QuizReviewBlock = {
  label?: string;
  kind: "code" | "markdown";
  content: string;
  tone?: "neutral" | "success" | "error" | "secondary";
};

export interface QuizReview {
  items: QuizReviewItem[];
}

export const isQuizReview = (review: unknown): review is QuizReview =>
  !!review && typeof review === "object" && "items" in review;
